<template>
  <el-dialog  title="装卸凭证" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="pingzhengWHFlag" width="1200px" center>
    <div>
      <el-form  :inline="true"  :model="goodform" ref="goodform" :rules="rules" class="demo-form-inline inpBox"  label-width="100px"  size="mini"  >
        <el-form-item label="运单状态:" prop="wayState" >
           {{goodform.wayStateName}}
        </el-form-item>
        <br>
        <!-- 审核通过不能改装卸凭证 -->
        <div v-if="goodform.auditStatus==1">
          <div style="">
            <h4 style="margin-left:16px;color:#0c46a2">装车</h4>
            <div style="padding-left:20px">
              <el-form-item label="装车量:" label-width="70px"   >
                <div class="width1">{{goodform.truckload?goodform.truckload:'-'}}{{goodform.measuringUnit}}</div>
              </el-form-item>
              <el-form-item label="装车时间:"  >
                <div class="width1">{{goodform.actualLoadingTime|dateFormat}}</div>
              </el-form-item>
            </div>
            <div v-if="ZCimgList.length>0">
              <div class="imgBox">
                <el-image
                  v-for="(item,index) in ZCimgList" :src="item.url" :key="index"
                  :preview-src-list="getSrcList(index,ZCimgList)">
                </el-image>
              </div>
              <div><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{ZCimgList[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{ZCimgList[0].createTime|dateFormat}} </span></div>
            </div>
          </div>
          <div style="">
            <h4 style="margin-left:16px;color:#0c46a2">卸车</h4>
            <div style="padding-left:20px">
              <el-form-item label="卸车量:" label-width="70px"  >
                <div class="width1">{{goodform.unloadings?goodform.unloadings:'-'}}{{goodform.measuringUnit}}</div>
              </el-form-item>
              <el-form-item label="卸车时间:"  >
                <div class="width1">{{goodform.actualUnloadingTime|dateFormat}}</div>
              </el-form-item>
            </div>
            <div v-if="XCimgList.length>0">
              <div class="imgBox">
                <el-image
                  v-for="(item,index) in XCimgList" :src="item.url" :key="index"
                  :preview-src-list="getSrcList(index,XCimgList)">
                </el-image>
              </div>
              <div><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{XCimgList[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{XCimgList[0].createTime|dateFormat}} </span></div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="addressBox" v-if="goodform.wayState>=2">
            <h4 class="title">
              <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>装车</span>
            </h4>
            <el-form-item label="装车量:"  prop="truckload" class="danweiBox width1 jiage" >
              <el-input  placeholder="" v-number-input.float="3"  @blur="zcFn"  maxlength="8"  v-model="goodform.truckload" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
              <el-input  placeholder="" v-number-input.float="0"  @blur="zcFn" maxlength="8"  v-model="goodform.truckload" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
              <span class="danwei">{{goodform.measuringUnit}}</span>
            </el-form-item>
            <el-form-item label="装车时间:" prop="actualLoadingTime">
                  <el-date-picker  v-model="goodform.actualLoadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"></el-date-picker>
            </el-form-item>
            <uploadImgs :imgList.sync='ZCimgList' :max=10 @remove="remove"></uploadImgs>
            <div style="margin-bottom:20px; font-size: 14px;" v-if="ZCimgList.length>0">
              <span style="margin: 10px 50px 10px 10px;">上传人：{{ZCimgList[0].createUser}}</span>
              <span>上传时间：{{ZCimgList[0].createTime|dateFormat}} </span></div>
          </div>
          <div class="addressBox" v-if="goodform.wayState>=3">
            <h4 class="title">
              <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>卸车</span>
            </h4>
            <el-form-item label="卸车量:"  prop="unloadings" class="danweiBox width1 jiage">
              <el-input  placeholder="" v-number-input.float="3" @blur="xcFn"  maxlength="8"  v-model="goodform.unloadings" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
              <el-input  placeholder="" v-number-input.float="0" @blur="xcFn"  maxlength="8"  v-model="goodform.unloadings" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
              <span class="danwei">{{goodform.measuringUnit}}</span>
            </el-form-item>
            <el-form-item label="卸车时间:" prop="actualUnloadingTime">
                  <el-date-picker  v-model="goodform.actualUnloadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime" @change="actualUnloadingTimeFn"></el-date-picker>
            </el-form-item>
            <div style="margin:0 0 10px 15px; font-size: 14px;">*回单</div>
            <uploadImgs :imgList.sync='XCimgList' :max=10 @remove="remove"></uploadImgs>
            <div style="margin-bottom:20px; font-size: 14px;"  v-if="XCimgList.length>0">
              <span style="margin: 10px 50px 10px 10px;">上传人：{{XCimgList[0].createUser}}</span>
              <span>上传时间：{{XCimgList[0].createTime|dateFormat}} </span></div>
          </div>
        </div>

        <div class="addressBox" v-if="goodform.wayState>=4&&(goodform.auditStatus==1||goodform.auditStatus==3)">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>签收</span>
          </h4>
          <!-- <el-form-item label="签收状态:" prop="signedState"  class="width1" >
            <el-select  v-model="goodform.signedState"  placeholder="请选择">
              <el-option  label="正常签收" :value="0" ></el-option>
              <el-option  label="异常签收" :value="1" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  >
            <el-input  placeholder="备注"    maxlength="50" v-model="goodform.signRemark"  ></el-input>
          </el-form-item> -->
          <el-form-item label="结算量:"  class="danweiBox width1 jiage" >
            <el-input  placeholder="" v-number-input.float="3" @blur="jsFn"  maxlength="8"  v-model="goodform.liquidatedAmount" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0" @blur="jsFn"  maxlength="8"  v-model="goodform.liquidatedAmount" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <span class="danwei">{{goodform.measuringUnit}}</span>
          </el-form-item>
          <el-form-item label="签收时间:" prop="actualSigningTime">
                <el-date-picker  v-model="goodform.actualSigningTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime" @change="actualSigningTimeFn"></el-date-picker>
          </el-form-item>
          <!-- <uploadImgs :imgList.sync='QSimgList' :max=10 @remove="remove"></uploadImgs>
          <div style="margin-bottom:20px; font-size: 14px;" v-if="QSimgList.length>0">
            <span style="margin: 10px 50px 10px 10px;">上传人：{{QSimgList[0].createUser}}</span>
            <span>上传时间：{{QSimgList[0].createTime|dateFormat}} </span></div> -->
        </div>
      </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveFn('goodform')" :loading="loading">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import { updateProof, queryWayImg, insertWayImg, delWayImg } from '@/api/newTMS'
import { dateFormatUtil } from '@/utils/util'
export default {
  name: 'zhuagnxiepingzheng',
  props: {
    pingzhengWHFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    uploadImgs
  },
  data () {
    return {
      dateFormatUtil: dateFormatUtil,
      ZCimgList: [],
      XCimgList: [],
      QSimgList: [],
      goodform: this.rowData,
      delImgIds: [],
      loading: false,
      rules: {
        truckload: [
          { required: true, message: '请输入装车量', trigger: 'blur' }
        ],
        unloadings: [
          { required: true, message: '请输入卸车量', trigger: 'blur' }
        ],
        liquidatedAmount: [
          { required: true, message: '请输入结算量', trigger: 'blur' }
        ],
        actualLoadingTime: [
          { required: true, message: '请选择装车时间', trigger: 'blur' }
        ],
        actualUnloadingTime: [
          { required: true, message: '请选择卸车时间', trigger: 'blur' }
        ],
        actualSigningTime: [
          { required: true, message: '请选择签收时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.goodform.deleteAttachmentsIds = []
    queryWayImg({ wayNo: this.rowData.wayNo }).then(res => {
      res.loadingImgs.forEach(item => {
        this.ZCimgList.push({ status: 'ready', url: item.fileUrlOSS, id: item.id, createUser: item.createUserName, createTime: item.createTime })
      })
      res.unloadImgs.forEach(item => {
        this.XCimgList.push({ status: 'ready', url: item.fileUrlOSS, id: item.id, createUser: item.createUserName, createTime: item.createTime })
      })
    })
  },
  methods: {
    // 运单状态改变
    wayStateChange (e) {
      if (e == 3) {
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
      }
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.url)
      })
      return urls
    },
    zcFn () {
      if (this.goodform.truckload > 40) {
        this.$alert('装车量超过标载40吨！', '系统提示')
      }
    },
    xcFn () {
      if (this.goodform.unloadings > 40) {
        this.$alert('卸车量超过标载40吨！', '系统提示')
      }
    },
    jsFn () {
      if (this.goodform.truckload != this.goodform.unloadings) {
        let timer = setTimeout(() => {
          this.$alert('装车量和卸车量不一致！', '系统提示')
          clearTimeout(timer)
          timer = null
        })
      }
      if (this.goodform.unloadings != this.goodform.liquidatedAmount) {
        let timer = setTimeout(() => {
          this.$alert('结算量和卸车量不一致！', '系统提示')
          clearTimeout(timer)
          timer = null
        })
      }
      if (this.goodform.liquidatedAmount > 40) {
        let timer = setTimeout(() => {
          this.$alert('结算量量超过标载40吨！', '系统提示')
          clearTimeout(timer)
          timer = null
        })
      }
    },
    // 卸车时间
    actualUnloadingTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualLoadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('卸车时间需要大于装车时间', '系统提示')
        this.$set(this.goodform, 'actualUnloadingTime', null)
      }
    },
    // 签收时间
    actualSigningTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualUnloadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('签收时间需要大于卸车时间', '系统提示')
        this.$set(this.goodform, 'actualSigningTime', null)
      }
    },

    // 删除文件
    remove (file) {
      if (file.id) {
        this.delImgIds.push(file.id)
      }
    },
    saveFn () {
      let that = this
      this.loading = true
      if (this.ZCimgList.length == 0) {
        this.$alert('请选择装车凭证', '系统提示')
        this.loading = false
        return false
      }
      if (this.XCimgList.length == 0 && this.goodform.wayState >= 3) {
        this.$alert('请选择卸车凭证', '系统提示')
        this.loading = false
        return false
      }
      if (Number(this.goodform.liquidatedAmount) === 0 && this.goodform.wayState > 3) {
        this.$alert('结算量不能为0', '系统提示')
        this.loading = false
        return false
      }
      if (this.goodform.wayState == 4) { // 签收的时候默认签收状态为正常签收
        this.goodform.signedState = 1
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let zhuangxieForm = new FormData()
          zhuangxieForm.append('params', JSON.stringify(this.goodform))
          updateProof(zhuangxieForm).then(res => { // 装卸量时间修改
            loading.close()
            this.loading = false
            this.$emit('update:pingzhengWHFlag', false)
            this.$parent.searchFn()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
                that.loading = false
              }
            })
          })

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify({
            wayNo: this.goodform.wayNo,
            type: 1,
            imageType: 1
          }))
          this.ZCimgList.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          if (imgfile.get('files')) { // 走装车接口
            insertWayImg(imgfile).then(res => {
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                  that.loading = false
                }
              })
            })
          }

          let imgfile1 = new FormData()
          imgfile1.append('params', JSON.stringify({
            wayNo: this.goodform.wayNo,
            type: 2,
            imageType: 1
          }))
          this.XCimgList.forEach(item => {
            if (!item.id) {
              imgfile1.append('files', item.raw)
            }
          })
          if (imgfile1.get('files')) { // 走卸车车接口
            insertWayImg(imgfile1).then(res => {
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                  that.loading = false
                }
              })
            })
          }

          // 删除凭证
          if (this.delImgIds.length > 0) {
            delWayImg({
              wayNo: this.goodform.wayNo,
              ids: this.delImgIds.toString()
            }).then(res => {
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                  that.loading = false
                }
              })
            })
          }
        } else {
          that.loading = false
        }
      })
    },
    closeDialog () {
      this.$emit('update:pingzhengWHFlag', false)
    }

  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.is-disabled .el-input__inner {
    background: #eff0f1;
}
.width1  /deep/.el-input__inner{
  width:100px;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin: 6px;
  }
}
</style>
